import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.x4};
`;
export const WrapperLink = styled.div`
  margin-inline-end: ${({ theme }) => theme.spacing.x1};
  display: flex;
  align-items: center;
`;
export const WrapperLinkName = styled.div<{ $isActive }>`
  letter-spacing: 1px;
  font-size: ${({ theme }) => theme.fs.xxs};
  margin-inline-end: ${({ theme }) => theme.spacing.x1};
  ${({ $isActive }) =>
    $isActive
      ? css`
          font-weight: 500;
        `
      : css`
          font-weight: 300;
        `}
`;
export const WrapperLinkSvg = styled.div`
  font-size: ${({ theme }) => theme.fs.xxs} !important;
  color: ${({ theme }) => theme.palette.primary};
`;

export const PageTitle = styled.div`
  color: ${({ theme }) => theme.palette.primary};
  font-size: ${({ theme }) => theme.fs.lg};
  font-weight: 700;
  letter-spacing: 1;
  margin-bottom: ${({ theme }) => theme.spacing.x3};
  margin-top: ${({ theme }) => theme.spacing.x3};
`;
